module.exports = __webpack_public_path__ + "img/class-default-img.05a013f5.png";